module.exports = __webpack_public_path__ + "img/icon_3_4.06306db5.png";